import { defineNuxtPlugin } from '#app/nuxt'
import { LazyNovelRenderBlockquote, LazyNovelRenderCallout, LazyNovelRenderComponent, LazyNovelRenderImage, LazyNovelRenderPageBreak, LazyNovelRenderParagraph, LazyNovelRenderRichText, LazyNovelRenderSceneBreak, LazyNovelRenderVerse } from '#components'
const lazyGlobalComponents = [
  ["NovelRenderBlockquote", LazyNovelRenderBlockquote],
["NovelRenderCallout", LazyNovelRenderCallout],
["NovelRenderComponent", LazyNovelRenderComponent],
["NovelRenderImage", LazyNovelRenderImage],
["NovelRenderPageBreak", LazyNovelRenderPageBreak],
["NovelRenderParagraph", LazyNovelRenderParagraph],
["NovelRenderRichText", LazyNovelRenderRichText],
["NovelRenderSceneBreak", LazyNovelRenderSceneBreak],
["NovelRenderVerse", LazyNovelRenderVerse],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
